import React from 'react';
import { NavLink, withRouter } from 'react-router-dom';

const AuthoringTopNav = () => {
  return(
    <div className="topbar -admin-subnav">
      <div>
        <ul className="navigation -left">
          <li><small><em>Legacy authoring:</em></small></li>
          <li><NavLink to="/admin/authoring/evaluations" activeClassName="active">Evaluations</NavLink></li>
          <li><a href={`${window.authoringUrl}/metrics`}>Metrics</a></li>
        </ul>
      </div>
    </div>
  )
}

export default withRouter(AuthoringTopNav);



// WEBPACK FOOTER //
// modules/admin/components/AuthoringTopNav.js.jsx